<template>
    <v-dialog max-width="600" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on"></slot>
        </template>
        <v-card>
            <v-card-title>Cancel: {{customer.name}}</v-card-title>
            <v-card-text>
                <v-form ref="form" @submit.prevent>
                    <v-radio-group
                            v-model="cancelType"
                            label="Select cancel type"
                            v-if="customer.recurring"
                    >
                        <v-radio
                                label="Cancel only today"
                                :value="0"
                        >
                        </v-radio>
                        <v-radio
                                label="Cancel all recurring"
                                :value="1"
                        >
                        </v-radio>
                    </v-radio-group>
                    <v-text-field
                            v-if="cancelType === 0"
                            label="Note/Reason for canceling"
                            filled
                    >
                    </v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn text>close</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="$store.dispatch('showError', 'Feature is still being worked on.')">submit</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
    export default {
        name: "CancelCustomer",
        props:{
            customer:{
                required: true,
            }
        },
        data: () => ({
            cancelType: 0,
        })
    }
</script>

<style scoped>

</style>
